<template>
    <div class="loginbg" style="display: none;" id="login-main-hr">
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <form>
                            <div class="form-group">
                                <label for="username">Username</label>
                                <input v-model="username" type="text" name="username" class="form-control" id="username_login" placeholder="Enter Username">
                                <span class="help is-danger">{{username_error_msg}}</span>
                            </div>

                            <div class="form-group">
                                <label for="password">Password</label>
                                <div style="position:relative">
                                    <template v-if="isPasswordHide">
                                        <input v-model="password" type="password" name="password" class="form-control" id="password_login" placeholder="Enter password">
                                    </template>
                                    <template v-else>
                                        <input v-model="password" type="text" name="password" class="form-control" id="password_login" placeholder="Enter password">
                                    </template>
                                    <a v-on:click.prevent="hideShowPassword()">
                                        <template v-if="isPasswordHide">
                                            <i class="fa fa-eye" style="position:absolute;top:10px;right:12px;" ></i>
                                        </template>
                                        <template v-else>
                                            <i class="fa fa-eye-slash" style="position:absolute;top:10px;right:12px;" ></i>
                                        </template>
                                    </a>
                                </div>
                                <span class="help is-danger">{{password_error_msg}}</span>
                            </div>
                            <span class="help is-danger">{{error_msg_login}}</span>

                            <div class="form-check not-registered">
                                <!-- <input type="checkbox">
                                <span class="checkbox-placeholder"></span>
                                Remember me -->
                                <!-- <a :href="not_registered_url" target="_blank">Not Registered?</a> -->
                            </div>
                            <div>
                                <button :disabled="disableButtons.loginButton" id="loginbtn" type="submit" class="btn btn-primary" v-on:click.prevent="login(this)">{{buttonNames.loginButton}}</button>
                                <!-- <a :href="forgot_pass_url" target="_blank">Forgot password?</a> -->
                                <router-link style="float: right;" v-bind:to="{name: 'CustomerForgotPassword'}"> Forgot password?</router-link>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import Vue from 'vue';
    import {customer_login} from '../../config';
    import {HTTP} from '../../http-common';
    import EventBus from '.././event-bus';
    var self;

    export default {
        name: 'Login',
        data() {
            return {
                error_msg_login: "",
                username: "",
                password: "",
                not_registered_url: "",
                forgot_pass_url: "",
                username_error_msg: "",
                password_error_msg: "",

                forgot_pass_url: "",

                buttonNames : {
                    loginButton : 'Login',
                },

                disableButtons : {
                    loginButton : false,
                },
                swRegistration: null,
                isSubscribed: false,
                isPasswordHide: true,
            }
        },
        created: function () {

        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self.checkLocalStorage();
            // self.notificationBlock();
        },
        methods: {
            notificationBlock: function() {
                /**
                 * First we check if the Browser supports Notification
                 * If yes, we initialize Service Worker
                 * If no, no need to do anything
                 */
                if (('Notification' in window)) {
                    console.log('Web Notification is supported');
                    if (Notification.permission === "granted") {
                        initServiceWorker();
                    } else if (Notification.permission !== 'denied' || Notification.permission === "default") {
                        Vue.swal({
                            title: '',
                            text: 'Please Allow Browser Notifications to get realtime Chat Notifications',
                            type: 'info',
                            confirmButtonText: 'Allow',
                            showCancelButton: true,
                            // showCloseButton: true,
                            allowOutsideClick: false,
                            showLoaderOnConfirm: true
                        }).then((result) => {
                            if (result.value) {
                                Notification.requestPermission(function (status) {
                                    // console.log('Notification permission status:', status);
                                    if (status == "granted") {
                                        initServiceWorker();
                                    } else {
                                        updateSubscriptionOnServer(null);
                                    }
                                });
                            }
                        });
                    }
                }
            },
            initServiceWorker: function() {
                if ('serviceWorker' in navigator && 'PushManager' in window) {
                    console.log('Service Worker and Push is supported');
                    navigator.serviceWorker.register('/static/js/serviceworker.js')
                        .then(function (swReg) {
                            self.swRegistration = swReg;
                            swReg.update();
                            var serviceWorker;
                            if (swReg.installing) {
                                serviceWorker = swReg.installing;
                                // console.log('Service worker installing');
                            } else if (swReg.waiting) {
                                serviceWorker = swReg.waiting;
                                // console.log('Service worker installed & waiting');
                            } else if (swReg.active) {
                                serviceWorker = swReg.active;
                                // console.log('Service worker active');
                            }

                            if (serviceWorker) {
                                // console.log("sw current state", serviceWorker.state);
                                if (serviceWorker.state == "activated") {
                                    //If push subscription wasnt done yet have to do here
                                    // console.log("sw already activated - Do watever needed here");
                                    initializeUI();
                                }
                                serviceWorker.addEventListener("statechange", function (e) {
                                    // console.log("sw statechange : ", e.target.state);
                                    if (e.target.state == "activated") {
                                        // use pushManger for subscribing here.
                                        //console.log("Just now activated. now we can subscribe for push notification")
                                        // subscribeForPushNotification(reg);
                                        initializeUI();
                                    }
                                });
                            }
                            // console.log('Service Worker is registered', swReg);
                        })
                        .catch(function (error) {
                            console.error('Service Worker Error', error);
                        });
                        //created broadcast channel
                        const broadcast = new BroadcastChannel('notifychat');

                        //this is listening message from service worker once service worker publish message it will recieved 
                        //here
                        //realod page with url got from service worker
                        broadcast.onmessage = (event) => {
                            // console.log(event.data);
                            window.location.href = event.data.payload;
                        };
                } else {
                    console.warn('Push messaging is not supported');
                }
            },
            initializeUI: function() {
                subscribeUser();
                // Set the initial subscription value
                self.swRegistration.pushManager.getSubscription()
                    .then(function (subscription) {
                        self.isSubscribed = !(subscription === null);
                        updateSubscriptionOnServer(subscription);
                        if (self.isSubscribed) {
                            // console.log('User IS subscribed.');
                        } else {
                            // console.log('User is NOT subscribed.');
                        }
                    });
            },
            subscribeUser: function() {
                const applicationServerKey = urlB64ToUint8Array(process.env.APPLICATION_SERVER_KEY);
                self.swRegistration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: applicationServerKey
                }).then(function (subscription) {
                    console.log('User is subscribed.');
                    updateSubscriptionOnServer(subscription);
                    self.isSubscribed = true;
                })
                .catch(function (err) {
                    console.log('Failed to subscribe the user: ', err);
                });
            },
            updateSubscriptionOnServer: function(subscription) {
                if (subscription) {
                    //subscriptionJson.textContent = JSON.stringify(subscription);
                    sendSubscriptionToServer(JSON.stringify(subscription));
                    //subscriptionDetails.classList.remove('is-invisible');
                }
            },
            sendSubscriptionToServer: function(subscription) {
                var fields = {
                    'subscription': subscription,
                };
                var config = {
                    headers: { Authorization: "Bearer " + localStorage.getItem("tkn") }
                };

                HTTP.post("browser/subscription", fields, config)
                    .then(function (data) {
                        // console.log(JSON.stringify(data.data));
                    })
                    .catch(function (error) {
                        // console.log(error);
                    })
            },
            urlB64ToUint8Array: function(base64String) {
                const padding = '='.repeat((4 - base64String.length % 4) % 4);
                const base64 = (base64String + padding)
                    .replace(/\-/g, '+')
                    .replace(/_/g, '/');

                const rawData = window.atob(base64);
                const outputArray = new Uint8Array(rawData.length);

                for (let i = 0; i < rawData.length; ++i) {
                    outputArray[i] = rawData.charCodeAt(i);
                }
                return outputArray;
            },
            login: function() {
                var error = false;
                self.username_error_msg = '';
                self.password_error_msg = '';

                if(!self.username || self.username == null || self.username == "") {
                    self.username_error_msg = "The username field is required.";
                    error = true;
                }

                if(!self.password || self.password == null || self.password == "") {
                    self.password_error_msg = "The password field is required.";
                    error = true;
                }

                if(!error) {

                    self.buttonNames.loginButton = "Login...";
                    self.disableButtons.loginButton = true;
                    /*$('#loginbtn').text("Login...");
                    $("#loginbtn").attr("disabled", true);*/

                    var fields = {
                        email: self.username,
                        password: self.password,
                        access_permission: "backend_website",
                        portal: "website",
                    };

                    HTTP.post(customer_login, fields)
                        .then(function (data) {
                            console.log(data);

                            self.buttonNames.loginButton = "Login";
                            self.disableButtons.loginButton = false;
                            /*$('#loginbtn').text("Login");
                            $("#loginbtn").attr("disabled", false);*/

                            if (data.status == 200) {
                                localStorage.setItem("api_token", data.data.api_token);
                                localStorage.setItem("access_token", data.data.api_token);
                                if(data.data.role == 'user') {
                                    localStorage.setItem("login_role", data.data.role);
                                    localStorage.setItem("customer_obj", JSON.stringify(data.data.user_obj));
                                } else {
                                    localStorage.setItem("login_role", "customer");
                                    localStorage.setItem("customer_obj", JSON.stringify(data.data.customer_obj));
                                    if ('Notification' in window) {
                                        Notification.requestPermission().then(function(status) {
                                            if(status == 'granted') {
                                                localStorage.setItem("is-notification-enabled", true);
                                            } else {
                                                localStorage.setItem("is-notification-enabled", false);
                                            }
                                        });
                                    }
                                }
                                window.location.href = "/customer/dashboard";
                            }
                        })
                        .catch(function (error) {
                            self.error_msg_login = "";
                            self.buttonNames.loginButton = "Login";
                            self.disableButtons.loginButton = false;
                            /*$('#loginbtn').text("Login");
                            $("#loginbtn").attr("disabled", false);*/
                            if (error.response.status == 0) {
                                self.error_msg_login = "Remote server can not be reachable";
                            }else if (error.response.status == 422) {
                                console.log(error.response);
                                self.username_error_msg = error.response.data.email[0];
                                self.password_error_msg = error.response.data.password[0];
                            } else {
                                if (error.response.data.message) {
                                    self.error_msg_login = error.response.data.message;
                                }
                            }
                        })

                }
            },
            checkLocalStorage : function () {
                if(localStorage.getItem('user_obj')) {

                    var userObj = localStorage.getItem('user_obj');
                    if (userObj != null && userObj !== "") {

                        self.$router.push('/dashboard');
                        // self.showHeader = true;
                        // alert("Hello");
                    } else {
                        self.$router.push('/');
                    }
                } else {
                    self.forgot_pass_url = process.env.HR_URL + "?identify=" + window.location.href;
                    self.not_registered_url = process.env.NOT_REGISTERED_HR_URL + "?identify=" + window.location.href;
                    $('#main-header').hide();
                    $('#sidebar-wrapper').hide();
                    $("#wrapper").addClass("login-div-full");

                    $(".loginbg").show();
                }
            },
            hideShowPassword: function() {
                self.isPasswordHide = !self.isPasswordHide;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Login/CustomerLogin.vue